import LOOKUP_TYPES, {
  MILESTONE_SIDE_BAR_ACTIONS,
} from '../../common/constants/SuccessPlanConstants';
import responseFormatter from '../../common/util/ResponseFormatter';
import {
  fetchMilestonesV2,
  fetchMilestoneByIdV2,
  fetchMilestoneStatusLookupsV2,
  completeMilestoneV2,
  markMilestoneInprogressV2,
  cancelMilestoneCompleteV2,
  fetchMilestoneStatusV2,
  archiveMilestoneV2,
  milestoneDrawerStateV2,
  milestoneTaskDrawerStateV2,
  milestoneTaskCompleteV2,
  createMilestoneV2,
  editMilestoneV2,
  refreshMilestoneBoardByIdV2,
  updateRefreshMilestoneIds,
} from '../routines/successPlanRoutines';

const { MILESTONE_STATUS } = LOOKUP_TYPES;
const initialState = {
  successPlanId: null,
  [MILESTONE_STATUS]: {
    data: [],
    dataMap: {},
    loading: false,
    error: null,
  },
  milestone: {
    data: {
      taskList: [],
    },
    loading: false,
    error: null,
  },
  milestones: {
    ids: [],
    data: {},
    loading: false,
    error: null,
  },
  milestoneRefreshIds: [],
  milestoneStatus: {
    data: null,
    loading: false,
    error: null,
    showModal: false,
    action: MILESTONE_SIDE_BAR_ACTIONS.EDIT,
  },
  drawer: {
    action: null,
    visibility: false,
  },
  taskDrawer: {
    action: null,
    visibility: false,
  },
  taskModel: {
    visibility: false,
  },
};

const successPlanMilestoneReducerV2 = (state = initialState, action) => {
  switch (action.type) {
    case cancelMilestoneCompleteV2.TRIGGER:
    case completeMilestoneV2.SUCCESS:
    case markMilestoneInprogressV2.SUCCESS: {
      return {
        ...state,
        milestoneStatus: {
          ...state.milestoneStatus,
          data: null,
          loading: false,
          error: null,
          showModal: false,
        },
      };
    }
    case fetchMilestoneStatusV2.TRIGGER: {
      return {
        ...state,
        milestoneStatus: {
          ...state.milestoneStatus,
          data: null,
          loading: true,
          error: null,
          showModal: true,
          action: action.payload.action,
        },
      };
    }
    case fetchMilestoneStatusV2.SUCCESS: {
      return {
        ...state,
        milestoneStatus: {
          ...state.milestoneStatus,
          data: action.payload,
          loading: false,
        },
      };
    }
    case fetchMilestoneStatusV2.FAILURE: {
      return {
        ...state,
        milestoneStatus: {
          ...state.milestoneStatus,
          data: null,
          loading: false,
          error: action.payload.error,
          showModal: false,
        },
      };
    }
    case fetchMilestonesV2.TRIGGER: {
      const {
        payload: { successPlanId },
      } = action;

      return {
        ...state,
        successPlanId,
        milestones: { ...state.milestones, loading: true },
      };
    }
    case fetchMilestonesV2.FAILURE: {
      return {
        ...state,
        milestones: {
          data: {},
          ids: [],
          error: action.payload.error,
          loading: false,
        },
      };
    }
    case fetchMilestonesV2.SUCCESS: {
      return {
        ...state,
        milestones: {
          ids: action.payload.map((item) => item.milestoneId),
          data: responseFormatter(action?.payload, 'milestoneId'),
          loading: false,
          error: null,
        },
      };
    }

    case fetchMilestoneByIdV2.TRIGGER: {
      const { milestoneId } = action.payload;
      return {
        ...state,
        milestones: {
          ...state.milestones,
          data: {
            ...state.milestones.data,
            [milestoneId]: {
              ...state.milestones.data[milestoneId],
              loading: true,
            },
          },
        },
        milestone: {
          ...state.milestone,
          loading: true,
        },
      };
    }
    case fetchMilestoneByIdV2.FAILURE: {
      const { milestoneId } = action.payload;
      return {
        ...state,
        milestones: {
          ...state.milestones,
          data: {
            ...state.milestones.data,
            [milestoneId]: {
              ...state.milestones.data[milestoneId],
              error: action.payload.error,
              loading: false,
            },
          },
        },
        milestone: {
          ...state.milestone,
          loading: true,
        },
      };
    }
    case fetchMilestoneByIdV2.SUCCESS: {
      const { milestoneId, successPlanId } = action.payload;
      if (successPlanId !== state.successPlanId) {
        return state;
      }

      return {
        ...state,
        milestones: {
          ...state.milestones,
          data: {
            ...state.milestones.data,
            [milestoneId]: {
              ...state.milestones.data[milestoneId],
              ...action.payload,
              loading: false,
            },
          },
        },
        milestone: {
          ...state.milestone,
          data: {
            ...state.milestone.data,
            ...action.payload,
          },
          loading: false,
        },
      };
    }
    case fetchMilestoneStatusLookupsV2.TRIGGER: {
      return {
        ...state,
        [MILESTONE_STATUS]: { ...state[MILESTONE_STATUS], loading: true },
      };
    }
    case fetchMilestoneStatusLookupsV2.FAILURE: {
      return {
        ...state,
        [MILESTONE_STATUS]: {
          ...state[MILESTONE_STATUS],
          error: action.payload.error,
          loading: false,
        },
      };
    }
    case fetchMilestoneStatusLookupsV2.SUCCESS: {
      return {
        ...state,
        [MILESTONE_STATUS]: {
          ...state[MILESTONE_STATUS],
          data: action.payload,
          dataMap: responseFormatter(action.payload, 'lookupId'),
          loading: false,
          error: null,
        },
      };
    }
    case updateRefreshMilestoneIds.TRIGGER: {
      const { milestoneId, isClear } = action.payload;
      let milestoneRefreshIdsCopy = state.milestoneRefreshIds;
      if (isClear) {
        milestoneRefreshIdsCopy = [];
      } else {
        milestoneRefreshIdsCopy = [...state.milestoneRefreshIds, milestoneId];
      }
      return {
        ...state,
        milestoneRefreshIds: milestoneRefreshIdsCopy,
      };
    }
    case refreshMilestoneBoardByIdV2.SUCCESS: {
      const { milestoneId } = action.payload;
      return {
        ...state,
        milestones: {
          ...state.milestones,
          data: {
            ...state.milestones.data,
            [milestoneId]: {
              ...state.milestones.data[milestoneId],
              ...action.payload,
            },
          },
        },
        milestoneRefreshIds: state.milestoneRefreshIds.filter(
          (id) => id !== milestoneId
        ),
      };
    }
    case refreshMilestoneBoardByIdV2.FAILURE: {
      const { milestoneId } = action.payload;
      return {
        ...state,
        milestones: {
          ...state.milestones,
          data: {
            ...state.milestones.data,
            [milestoneId]: {
              ...state.milestones.data[milestoneId],
            },
          },
        },
        milestoneRefreshIds: state.milestoneRefreshIds.filter(
          (id) => id !== milestoneId
        ),
      };
    }
    case archiveMilestoneV2.SUCCESS:
      return {
        ...state,
        milestoneStatus: {
          ...state.milestoneStatus,
          showModal: false,
        },
      };
    case milestoneDrawerStateV2.TRIGGER: {
      return {
        ...state,
        milestone: {
          ...state.milestone,
          data: action.payload.milestoneId
            ? state.milestones.data[action.payload.milestoneId]
            : {},
        },
        drawer: {
          ...state.drawer,
          action: action.payload.action,
          visibility: action.payload.visibility,
          milestoneId: action.payload.milestoneId,
        },
      };
    }
    case milestoneTaskDrawerStateV2.TRIGGER: {
      return {
        ...state,
        taskDrawer: {
          ...state.taskDrawer,
          action: action.payload.action,
          visibility: action.payload.visibility,
          taskId: action.payload.taskId,
          onTaskSave: action.payload.onTaskSave,
          onCreateComplete: action.payload.onCreateComplete,
        },
      };
    }
    case milestoneTaskCompleteV2.TRIGGER: {
      return {
        ...state,
        taskModel: {
          ...state.taskModel,
          visible: action.payload.visible,
          isResolved: action.payload.isResolved,
          onResolve: action.payload.onResolve,
          onConfirm: action.payload.onConfirm,
          confirmText: action.payload.confirmText,
          onCancel: action.payload.onCancel,
        },
      };
    }
    case editMilestoneV2.TRIGGER:
    case createMilestoneV2.TRIGGER: {
      return {
        ...state,
        milestone: {
          ...state.milestones,
          loading: true,
        },
      };
    }
    case editMilestoneV2.SUCCESS:
    case createMilestoneV2.SUCCESS: {
      return {
        ...state,
        milestone: {
          ...state.milestones,
          loading: false,
        },
      };
    }
    case editMilestoneV2.FAILURE:
    case createMilestoneV2.FAILURE: {
      return {
        ...state,
        milestone: {
          ...state.milestones,
          loading: false,
          error: action.payload.error,
        },
      };
    }
    default:
      return state;
  }
};

export default successPlanMilestoneReducerV2;
